// @core/api/endpoints/workflow/update_prompt_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PromptTemplateResponse,
  UpdatePromptTemplateRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Update prompt template
 * Updates a prompt template. Builtin templates cannot be edited — clone them instead.
 */
export async function UpdatePromptTemplate(
  template_id: string,
  data: UpdatePromptTemplateRequest,
  options?: RequestOptions
): Promise<PromptTemplateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/prompt-templates/:template_id`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.patch<PromptTemplateResponse>(requestPath, data, requestOptions);
}
